<template>
  <v-card>

    <v-toolbar
      v-if="!readonly"
      dense
      flat
    >
      Edit News Article
      <v-spacer />
      <v-btn
        :disabled="loading || saving"
        small
        @click="$emit('cancel')"
      >
        Cancel
      </v-btn>
      <v-btn
        :disabled="!changed || loading || saving"
        color="primary"
        small
        @click="saveNa()"
      >
        Save Changes
      </v-btn>
    </v-toolbar>

    <v-expand-transition>
      <div
        v-if="saving"
        style="margin:auto;background:rgba(0,0,0,0.1)"
      >
        <v-progress-linear
          indeterminate
          hide-details
          style="margin:0;"
        />
      </div>
    </v-expand-transition>

    <v-expand-transition>
      <v-card-text
        v-if="!loading && focusNewsarticle"
      >
        <v-text-field
          label="Title"
          v-model="focusNewsarticle.title"
          :disabled="saving || readonly"
        />
        <div
          style="padding: 5px;background: rgba(0,0,0,0.05);border-radius: 5px;"
        >
          <span
            v-if="focusNewsarticle.casetype"
          >
            <b>Case Type: </b> {{ focusNewsarticle.casetype.name }}<br />
          </span>
          <b>Created by </b> {{ focusNewsarticle.created_by_name }} on {{ convertToLocal(focusNewsarticle.created_at) }}<br />
          <b>Last Updated by </b> {{ focusNewsarticle.updated_by_name }} on {{ convertToLocal(focusNewsarticle.updated_at) }}<br />
        </div>
        <v-card
          style="margin-top: 20px;"
          flat
        >
          <v-toolbar
            flat
            dense
          >
            Body
          </v-toolbar>
          <Editor
            v-if="!readonly"
            :enable_html="true"
            :enable_formatting='true'
            ref="htmlEditor"
            :html="focusNewsarticle.body"
            @changed="changed = true"
          />
          <div
            v-else
            v-html="focusNewsarticle.body"
          />
        </v-card>
        <v-card
          style="margin-top: 20px;"
          flat
        >
          <v-toolbar
            flat
            dense
          >
            Media
          </v-toolbar>
          <v-card-text>                                        
            <v-text-field
              label="Media URL"
              hint="Add videos from media platforms, such as YouTube, Vimeo, Facebook, Instagram, and more. Paste the link to the media you want to attach."
              persistent-hint
              :disabled="saving || readonly"
              v-model="focusNewsarticle.video_url"
            />
          </v-card-text>
        </v-card>
        <v-card
          style="margin-top: 20px;"
          flat
        >
          <v-toolbar
            flat
            dense
          >
            Files
            <v-spacer />
            <v-btn
              v-if="!readonly"
              :disabled="!focusNewsarticle.id"
              flat
              @click="fileDialog = true"
            >
              <v-icon left size="18">mdi-plus</v-icon>Upload File
            </v-btn>
          </v-toolbar>
          <v-expand-transition>
            <div
              v-if="loadingFiles"
              style="margin:auto;background:rgba(0,0,0,0.1)"
            >
              <v-progress-linear
                indeterminate
                hide-details
                style="margin:0;"
              />
            </div>
          </v-expand-transition>
          <v-card-text
            v-if="focusNewsarticle.id"
          >
            <div
              v-if="focusNewsarticle.files.length == 0"
            >
              There are no files attached to this article.
            </div>
            <div
              v-else
            >
              <div
                v-for="file in focusNewsarticle.files"
                :key="file.id"
                style="display: flex;padding: 5px;"
              >
                <div
                  style="flex-grow: 1;"
                >
                  {{ file.file }}<br />
                  <small><i>Uploaded by {{ file.created_by_name }} at {{ convertToLocal(file.created_at) }}</i></small>
                </div>
                <div
                  style="display:flex;align-items: center;justify-content: center;"
                >
                  <v-radio-group
                    v-if="isImageMime(file.file)"
                    v-model="cover_image"
                    hide-details
                    style="margin-top:unset;"

                  >
                    <v-radio label="Cover Image" :value="file.id" />
                  </v-radio-group>
                  <v-btn
                    icon
                    small
                    :disabled="loadingFiles || saving"
                    @click="downloadFile(file.id, file.file)"
                  >
                    <v-icon>
                      mdi-download
                    </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="!readonly"
                    icon
                    small
                    :disabled="loadingFiles || saving"
                    @click="deleteFile(focusNewsarticle.id, file.id)"
                  >
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-text
            v-else
          >
            To upload files to this article, save it first.
          </v-card-text>
        </v-card>
        <v-card
          style="margin-top: 20px;"
          flat
        >
          <v-toolbar
            flat
            dense
          >
            Settings
          </v-toolbar>
          <v-card-text
            style="padding-top: 0"
          >
            <v-checkbox
              v-model="focusNewsarticle.public"
              label="Public"
              :disabled="saving || readonly"
              hint="Allow anyone on the internet to view this article, attached media, and download attached files; even when not signed in"
              persistent-hint
            />
            <v-checkbox
              v-model="focusNewsarticle.archived"
              label="Archived"
              :disabled="saving || readonly"
              hint="Archive this article, including any attached files and media"
              persistent-hint
            />
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-text
        v-else
      >
        <div
          style="padding: 10px;margin:auto"
        >
          <div>
            Loading Article...
          </div>
          <v-progress-linear
            indeterminate
          />
        </div>
      </v-card-text>
    </v-expand-transition>
    <v-dialog
      v-model="fileDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-toolbar
          flat
          dense
          color="primary"
          dark
        >
          Upload File(s) to Article
        </v-toolbar>
        <v-card-text>
          <div>
            <v-alert
              type="info"
              :value="true"
            >
              Files attached to this article will be accessible to anyone on the internet if the article is set to public.
            </v-alert>
          </div><br />
          <div style="display:inline-block;width:100%;height:32px;color:lightgrey;font-size:18px;">
            <input
              type="file"
              ref="files"
              multiple
              v-on:change="handleFileUploads()"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="loading"
            @click="files = null;fileDialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="!files || loading"
            color="blue"
            flat
            @click="submitFiles()"
          >
            <v-icon left>cloud</v-icon> Upload File
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>



<script>
  import api from '@/api'
  import GlobalConstants from '@/globals'
  import Editor from '@/components/admin/Editor'
  import { mapActions } from 'vuex'

  export default {
    components: {
      Editor,
    },
    props: [ 'article', 'casetype', 'readonly' ],
    data () {
      return {
        saving: false,
        loading: true,
        changed: false,
        ignoreNext: false,
        focusNewsarticle: null,
        files: null,
        fileDialog: false,
        loadingFiles: false,
        cover_image: null
      }
    },
    created () {
      if (this.article !== 'new')
        this.getNa(this.article)
      else {
        this.focusNewsarticle = {
          title: "My New Article",
          casetype: this.casetype
        }
        this.loading = false
      }
    },
    methods: {
      isImageMime (file) {
        return file.match(/\.(jpg|jpeg|png|gif)$/i)
      },
      handleFileUploads () {
        this.files = this.$refs.files.files
      },
      downloadFile (fileId, file_name) {
        let fileDl = (this.focusNewsarticle.casetype)
          ? api.news.casenews.downloadFileUrl(this.focusNewsarticle.casetype.id, this.focusNewsarticle.id, fileId)
          : api.news.news.downloadFileUrl(this.focusNewsarticle.id, fileId)
        fileDl.then((response) => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = file_name.replace(/['"]/g, '')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
      },
      submitFiles () {
        this.loadingFiles = true
        this.fileDialog = false
        let formData = new FormData()
        for( var i = 0; i < this.files.length; i++ ){
          let file = this.files[i]
          formData.append(`upload`, file)
        }
        let uploadFileApi = (this.focusNewsarticle.casetype)
          ? api.news.managecasenews.uploadFile(this.focusNewsarticle.casetype.id, this.focusNewsarticle.id, formData)
          : api.news.allnews.uploadFile(this.focusNewsarticle.id, formData)
        uploadFileApi
          .then(response => {
            this.focusNewsarticle.files = response.files
          })
          .catch(err => {
            alert(err)
          })
          .finally(() => {
            this.loadingFiles = false
          })
      },
      deleteFile (articleId, fileId) {
        this.loadingFiles = true
        let delFileApi = (this.focusNewsarticle.casetype)
          ? api.news.managecasenews.deleteFile(this.focusNewsarticle.casetype.id, this.focusNewsarticle.id, fileId)
          : api.news.allnews.deleteFile(this.focusNewsarticle.id, fileId)
        delFileApi
          .then(() => {
            this.loadingFiles = false
            var index = this.focusNewsarticle.files.map(x => {
              return x.id
            }).indexOf(fileId)
            this.focusNewsarticle.files.splice(index, 1)
          })
      },
      getNa (id) {
        this.loading = true
        if (this.readonly) {
          api.news.casenews.get(this.casetype, id)
            .then((data) => {
              this.focusNewsarticle = data
              this.changed = false
              this.loading = false
            })
        } else {
          if (this.casetype)
            api.news.managecasenews.get(this.casetype, id)
              .then((data) => {
                this.focusNewsarticle = data
                this.changed = false
                this.loading = false
              })
          else
            api.news.allnews.get(id)
              .then((data) => {
                this.focusNewsarticle = data
                this.changed = false
                this.loading = false
              })
        }
      },
      saveNa () { 
        this.saving = true
        this.changed = false
        this.$emit('changed', this.changed)
        var html = this.$refs.htmlEditor.getHTML()
        this.focusNewsarticle.body = html
        let request = (this.casetype)
            ? api.news.managecasenews.save(this.casetype, this.focusNewsarticle)
            : api.news.allnews.save(this.focusNewsarticle)
        request.then((data) => {
          this.saving = false
          if (this.article == "new") {
            this.$emit('fetch')
            this.$emit('focus', data.id)
          } else {
            this.focusNewsarticle = data
            this.ignoreNext = true
          }
        })
      }
    },
    watch: {
      focusNewsarticle: {
        handler(newValue, oldValue) {
          if (this.loading || !this.article || oldValue == null || this.ignoreNext) {
            this.changed = false
            this.loading = false
            this.ignoreNext = false
          }
          else {
            if (!this.loading) {
              this.changed = true
            }
          }
          if (this.focusNewsarticle)
            if (this.focusNewsarticle.files.length > 0) {
              this.focusNewsarticle.files.forEach((f) => {
                if (f.cover_image)
                  this.cover_image = f.id
              })
            }
        },
        deep: true,
        flush: 'post'
      },
      cover_image () {
        let coverFileApi = (this.focusNewsarticle.casetype)
          ? api.news.managecasenews.coverFile(this.focusNewsarticle.casetype.id, this.focusNewsarticle.id, this.cover_image)
          : api.news.allnews.coverFile(this.focusNewsarticle.id, this.cover_image)
        coverFileApi
      },
      changed () {
        this.$emit('changed', this.changed)
      },
      article () {
        if (this.article !== 'new') {
          this.focusNewsarticle = null
          this.getNa(this.article)
        } else {
          this.focusNewsarticle = {
            title: "My New Article",
            casetype: this.casetype
          }
          this.loading = false
        }
      }
    }
  }
</script>